<template>
  <el-dialog
    title="发现设备"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="1200px"
    v-dialogDrag
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      inline
      @submit.native.prevent="search"
    >
      <el-form-item label="" prop="pIid" required>
        <el-select v-model="form.pIid" placeholder="实例名称" @change="search">
          <el-option
            v-for="item in instanceList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" :prop="item.value" v-for="(item, index) in formList" :key="index">
        <el-input
          v-model="form[item.value]"
          :placeholder="item.name"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" native-type="submit">搜索</el-button>
        <el-button class="!ml-10px" type="primary" :disabled="!selectionList.length" @click="addDevice(0)" :loading="saveLoading0">全量同步</el-button>
        <el-button class="!ml-10px" type="primary" :disabled="!selectionList.length" @click="addDevice(1)" :loading="saveLoading1">增量同步</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="tableRef"
      :data="tableData"
      border
      stripe
      height="430"
      v-loading="tableLoading"
      @selection-change="selectionChange"
    >
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column label="设备编码" prop="code"></el-table-column>
      <el-table-column label="设备名称" prop="name"></el-table-column>
      <el-table-column v-for="(item, index) in tableColumn" :key="index" :label="item.label" :prop="item.prop">
        <template slot-scope="{ row }">
          <div v-if="item.fieldType === 'bool'">
            {{ row[item.prop] === 'true' ? '是' : '否' }}
          </div>
          <div v-else>
            {{ row[item.prop] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="getList"
      @current-change="getList"
      :current-page.sync="initPagination.pageNum"
      :page-size.sync="initPagination.pageSize"
      :total="initPagination.total"
      layout="->,total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
  </el-dialog>
</template>

<script>
import { IOTDeviceTemplateApi, IOTDeviceProtocolInstanceApi, IOTDeviceApi } from '@wiz-api/iot-device-management'

const iOTDeviceApi = new IOTDeviceApi()
const ioTdeviceManagementApi = new IOTDeviceTemplateApi()
const iOTDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()
export default {
  name: 'findDevice',
  props: {
    show: Boolean,
    type: {
      type: String,
      default: 'edit',
    },
    detailRow: Object,
  },
  data() {
    return {
      instanceList: [],
      form: {
        pIid: ''
      },
      rules: {
        pIid: [{ required: true, message: '请选择实例名称', trigger: 'change' }]
      },
      formList: [],
      initPagination: {
        pageNum: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      selectionList: [],
      saveLoading0: false,
      saveLoading1: false,
      jsonContent: {},
      tableColumn: []
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
  },
  methods: {
    async addDevice(type) {
      this[`saveLoading${type}`] = true
      // const deviceInfos = this.selectionList.map((item) => {
      //   return {
      //     name: item.name,
      //     code: item.code,
      //     deviceDynamicsFieldValues: item.fieldValues
      //   }
      // })
      const [err] = await iOTDeviceApi.autoSyncIOTDevices({
        body: {
          tid: this.detailRow.id,
          pIid: this.form.pIid,
          syncScheme: type,
          deviceInfos: this.selectionList,
        }
      })
      if (!err) {
        this.$message.success('同步成功')
        this.$emit('reload')
        this.dialogShow = false
      }
      this[`saveLoading${type}`] = false
    },
    selectionChange(val) {
      this.selectionList = val
    },
    search() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.initPagination.pageNum = 1
          this.getList()
        }
      })
    },
    // 获取表单查询模板
    async getTemplate() {
      const [err, res] = await iOTDeviceApi.getRetrievalDeviceParam({
        tid: this.detailRow.id,
      })
      if (!err) {
        const formList = []
        const json = JSON.parse(res)
        Object.keys(json).forEach((key) => {
          formList.push({
            name: key,
            value: key
          })
        })
        this.form = { ...this.form, ...json }
        this.jsonContent = json
        this.formList = formList
      }
    },
    async getList() {
      this.tableLoading = true
      const formData = {}
      Object.keys(this.jsonContent).forEach((key) => {
        formData[key] = this.form[key]
      })
      const [err, res] = await iOTDeviceApi.retrievalDevice({
        pIid: this.form.pIid,
        tid: this.detailRow.id,
        protocolAPIParam: JSON.stringify(formData),
        skipCount: (this.initPagination.pageNum - 1) * this.initPagination.pageSize,
        maxResultCount: this.initPagination.pageSize,
      })
      if (!err) {
        const tableData = []
        res.items.forEach((item) => {
          const obj = {
            ...item,
          }
          item.deviceDynamicsFieldValues.forEach((fieldItem) => {
            obj[fieldItem.fieldName] = fieldItem.fieldValue
          })
          tableData.push(obj)
        })
        this.tableData = tableData
        this.initPagination.total = res.totalCount
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout()
        })
      }
      this.tableLoading = false
    },
    // 获取实例列表
    async getInstanceList() {
      const [err, res] = await iOTDeviceProtocolInstanceApi.getList({
        protocolCode: this.detailRow.protocolTypeCode,
        skipCount: 0,
        maxResultCount: 99,
      })
      if (!err) {
        this.instanceList = res.items
        if (res.items.length) {
          this.form.pIid = res.items[0].id
          this.search()
        }
      }
    },
    // 获取动态表头
    async getTableColumn() {
      const [err, res] = await ioTdeviceManagementApi.getIOTDeviceTemplateFields({ tid: this.detailRow.id })
      if (!err) {
        const column = []
        res.templateFields.forEach((item) => {
          item.label = item.fieldTitle
          item.prop = item.fieldName
          if (item.showList) {
            column.push(item)
          }
        })
        this.tableColumn = column
      }
    },
  },
  created() {
    this.getTemplate()
    this.getTableColumn()
    this.getInstanceList()
  }
}
</script>
